import { useState } from "react";
import { useLocalization } from "@fluent/react";
import { LoadingShim } from "@narmi/design_system";
import SectionCard from "../SectionCard";
import SignedUrlIframe from "../SignedUrlIframe";
import { useUserFeatures } from "../contexts/UserFeaturesContext";
import useIsChartCardEnabled from "./ChartCard.hooks";

const ChartCard = () => {
  const { l10n } = useLocalization();
  const features = useUserFeatures();
  const isChartCardEnabled = useIsChartCardEnabled();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  
  if (error || !isChartCardEnabled) return null;
  const { mx_mini_widget_endpoint: mxMiniWidgetEndpoint } = features;
  const endpoint = mxMiniWidgetEndpoint ?? "signed_urls/mx/urls/net_worth_widget";
  const titleKey = (endpoint === "signed_urls/mx/urls/spending_widget") ? "heading-spending" : "heading-net-worth";

  return (
    <SectionCard classNames="dashboard-section-card">
      <LoadingShim isLoading={loading}>
        <div style={{ minHeight: 200 }}>
          <SectionCard.Title text={l10n.getString(titleKey)} />
          <SignedUrlIframe
            endpoint={endpoint}
            height="550px"
            setLoading={setLoading}
            setError={setError}
          />
        </div>
      </LoadingShim>
    </SectionCard>
  );
};

export default ChartCard;
